import { useState } from "react";
import { ChevronDown, ExternalLink } from "lucide-react";
import { LeaningBadge } from "@/components/Leaning";

const ROLE = { original: "Original source", corroborating: "Corroborates", conflicting: "Conflicts" };

const uniqueRefs = (f) => {
  const seen = new Set();
  return [["original", f.original], ...(f.conflicting || []).map((r) => ["conflicting", r]), ...(f.corroborating || []).map((r) => ["corroborating", r])]
    .filter(([, r]) => r && !seen.has(r.record_id || r.url) && seen.add(r.record_id || r.url));
};

export const ViewSources = ({ f }) => {
  const [open, setOpen] = useState(false);
  const refs = uniqueRefs(f);
  if (!refs.length) return null;
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  return (
    <div className="mt-3 border-t border-border pt-3" onClick={stop}>
      <button type="button" onClick={(e) => { stop(e); setOpen(!open); }} aria-expanded={open} data-testid={`fact-view-sources-${f.id}`}
        className="inline-flex items-center gap-1 text-xs font-semibold text-[hsl(var(--facts))] hover:underline">
        View sources ({refs.length})<ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="mt-2 space-y-1.5" data-testid={`fact-sources-list-${f.id}`}>
          {refs.map(([role, r]) => (
            <li key={`${role}-${r.record_id || r.url}`} className="flex flex-wrap items-center gap-2 text-xs text-slate-600">
              <span className={`w-24 shrink-0 font-semibold ${role === "conflicting" ? "text-amber-700" : "text-slate-500"}`}>{ROLE[role]}</span>
              <span className="font-medium text-slate-800">{r.source_name}</span>{r.leaning && <LeaningBadge leaning={r.leaning} />}
              {r.url && <span role="link" tabIndex={0} onClick={(e) => { stop(e); window.open(r.url, "_blank", "noopener,noreferrer"); }}
                onKeyDown={(e) => e.key === "Enter" && (stop(e), window.open(r.url, "_blank", "noopener,noreferrer"))}
                className="inline-flex cursor-pointer items-center gap-0.5 text-[hsl(var(--facts))] hover:underline" data-testid={`fact-source-link-${f.id}-${role}-${r.record_id}`}>Open original<ExternalLink size={11} /></span>}
            </li>
          ))}
          <li className="pt-1 text-[11px] text-slate-400">Middle links to the original reporting rather than copying it.</li>
        </ul>
      )}
    </div>
  );
};
